import React, { useEffect, useState } from "react";
// import StrikedPrice from "./StrikedPrice";
import PriceOffer from "./PriceOffer";
import SelectMultiVariant from "../../screens/NewProductScreen/SelectMultiVariant";
import SelectQty from "../../screens/NewProductScreen/SelectQty";
import SummaryBeforeAddToCart from "./SummaryBeforeAddToCart";
import "./textInBorder.css";
import AddCartButton from "../../screens/NewProductScreen/AddCartButton";
import ShippingMessage from "../../screens/AdminShippingMessage/ShippingMessage";
import ScarcityMessage from "../../screens/AdminShippingMessage/ScarcityMessage";
import AdvantagesBoard from "../../screens/AdvantagesBoard/AdvantagesBoard";
import ErcModal from "../../modules/shared/components/ErcModal";
import SideProducts from "../SideProducts/SideProducts";
import { useCalculateValidPrice } from "../../hooks/useCalculateValidPrice";

export default function PurchaseComponent(props) {
  // PROPS COMING FROM ProductScreenNew
  const {
    isPending,
    qty,
    price,
    isDiscountValid,
    remainingTime,
    cartSkuItems,
    product,
    variants,
    setChoosenVariants,
    choosenVariants,
    setVariantAlert,
    variantAlert,
    setNoSkuAlert,
    qtyAlert,
    setQty,
    setQtyAlert,
    disableButton,
    addToCartHandler,
    noSkuAlert,
    productCampaign,
    loadingProduct,
    errorProduct,
    width,
    skuData,
    createdFingerPrint,
    loadingSideProducts,
    errorSideProducts,
    sideProducts,
  } = props;

  const [normalisedQty, setNormalisedQty] = useState(1);
  useEffect(() => {
    if (qty === "0") {
      setNormalisedQty(0);
    } else if (qty === 0) {
      setNormalisedQty(0);
    } else if (qty > 0 || qty > "0") {
      setNormalisedQty(Number(qty));
    }
  }, [qty]);

  // CALCULATE THE VALID PRICE
  const validPrice = useCalculateValidPrice(price, isDiscountValid);

  return (
    <>
      <div className="col w100p">
        <PriceOffer
          product={product}
          price={price}
          validPrice={validPrice}
          isDiscountValid={isDiscountValid}
          remainingTime={remainingTime}
          isPending={isPending}
          cartSkuItems={cartSkuItems}
        />
      </div>

      <div className="col-jus-webkit">
        <SelectMultiVariant
          singleSku={variants.singleSku}
          fullVariantsArray={variants.fullVariantsArray}
          setChoosenVariants={setChoosenVariants}
          choosenVariants={choosenVariants}
          setVariantAlert={setVariantAlert}
          variantAlert={variantAlert}
          setNoSkuAlert={setNoSkuAlert}
        />

        <SelectQty
          product={product}
          qtyAlert={qtyAlert}
          setQty={setQty}
          setQtyAlert={setQtyAlert}
        />

        <SummaryBeforeAddToCart
          product={product}
          isDiscountValid={isDiscountValid}
          price={price}
          normalisedQty={normalisedQty}
          validPrice={validPrice}
          isThereApendingOrder={isPending && isPending.isTherePending}
          cartSkuItems={cartSkuItems}
        />
      </div>

      {Array.from(product.skus.map((sku) => sku.countInStock)).reduce(
        (a, c) => a + c,
        0
      ) > 0 && (
        <>
          <AddCartButton
            cartSkuItems={cartSkuItems}
            product={product}
            disableButton={disableButton}
            addToCartHandler={addToCartHandler}
            noSkuAlert={noSkuAlert}
            isThereApendingOrder={isPending && isPending.isTherePending}
          />

          {product.sideProducts.length > 0 && (
            <div className="col w90p white-border3 padupsideq marupsideq">
              <p className="fs1125 helvetica">Tüm Sete Bir Göz Atın</p>
              <div className="w100p row-center-webkit">
                <img
                  className="cart-product-img"
                  src={product.sideProductsImage}
                  alt="beddo™"
                />
                <ErcModal
                  modalTitle={() => (
                    <div>
                      <button
                        type="button"
                        className="small-primary-green w95p"
                        /* onClick={() =>
                          sideProductsRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          })
                        }*/
                      >
                        Şimdi Göz At
                      </button>
                    </div>
                  )}
                  modalFrontWidth={"80%"}
                  modalTitleDivWidth={"50%"}
                  modalTitleFontSize={"0.85rem"}
                  modalTitleLineHeight={"2rem"}
                  modalTitleColor={"#0645ad"}
                  contentTitle={`Tüm Seti Alın Rahat Edin`}
                  contentTitleFontSize={"1.35rem"}
                  content={[
                    <SideProducts
                      loadingProduct={loadingProduct}
                      errorProduct={errorProduct}
                      product={product}
                      addToCartHandler={addToCartHandler}
                      width={width}
                      skuData={skuData}
                      setNoSkuAlert={setNoSkuAlert}
                      isThereApendingOrder={
                        isPending && isPending.isTherePending
                      }
                      isDiscountValid={isDiscountValid}
                      remainingTime={remainingTime}
                      createdFingerPrint={createdFingerPrint}
                      loadingSideProducts={loadingSideProducts}
                      errorSideProducts={errorSideProducts}
                      sideProducts={sideProducts}
                    />,
                  ]}
                  modalParagBorderBottom={"0.1rem solid #ff9935"}
                  modalParagFontSize={"1.25rem"}
                />
              </div>
            </div>
          )}
          <div className="w90p row-center-webkit white-border3 padupsideq marupsideq">
            <ShippingMessage product={product} />
          </div>
          <div className="w90p col white-border3 padupsideq marupsideq">
            <ScarcityMessage product={product} />
          </div>
          <AdvantagesBoard
            product={product}
            productCampaign={productCampaign}
            cartSkuItems={cartSkuItems}
            eCommerce={true}
            isDiscountValid={isDiscountValid}
            isPending={isPending}
          />
        </>
      )}
    </>
  );
}
